module.exports = __webpack_public_path__ + "static/GT-America-Standard-Bold-ea9889807af004e0bb28f8d437d46236.woff";